var styles = {"modalBody":"VDS__MON__modal-body-module__a7dyn","noCloseButton":"VDS__MON__modal-body-module__EgfYt","noTitle":"VDS__MON__modal-body-module__C8751","dark":"VDS__MON__modal-body-module__LNAAi"};

export { styles as default };
